import { Route, Navigate } from "react-router-dom";

import Home from "../pages/public/Home";
import About from "../pages/public/About";
import Contact from "../pages/public/Contact";
import Privacy from "../pages/public/Privacy";
import Terms from "../pages/public/Terms";
import Support from "../pages/public/Support";

import LoginPage from "../pages/auth/LoginPage";
import SignupPage from "../pages/auth/SignupPage";
import ForgotPasswordPage from "../pages/auth/ForgotPasswordPage";
import ResetPasswordPage from "../pages/auth/ResetPasswordPage";
import Plans from "../pages/public/Plan";
import Templates from "../pages/public/Templates";
import { getToken, getUser } from "../api/auth";
import XMLTester from "../pages/public/XMLTester";
import Unauthorized from "../pages/public/Unauthorized";

function RootHandler() {
  let user = null;
  let token = null;

  try {
    user = getUser();
    token = getToken();
  } catch {
    user = null;
    token = null;
  }

  // No valid login → show Home
  if (!user || !token) {
    return <Home />;
  }

  // Logged in → redirect based on role
  if (user.role === "admin") {
    return <Navigate to="/admin" replace />;
  }

  if (user.role === "organization") {
    return <Navigate to="/organization" replace />;
  }

  return <Navigate to="/user" replace />;
}

export default function PublicRoutes() {
  return (
    <>
      <Route path="/" element={<RootHandler />} />

      <Route path="/about" element={<About />} />

      <Route path="/contact" element={<Contact />} />

      <Route path="/support" element={<Support />} />

      <Route path="/privacy" element={<Privacy />} />

      <Route path="/terms" element={<Terms />} />

      <Route path="/sign-in" element={<LoginPage />} />

      <Route path="/plans" element={<Plans />} />

      <Route path="/sign-up" element={<SignupPage />} />

      <Route path="/templates" element={<Templates />} />

      <Route path="/forgot-password" element={<ForgotPasswordPage />} />

      <Route path="/reset-password/:token" element={<ResetPasswordPage />} />

      <Route path="/xml-tester" element={<XMLTester />} />

      <Route path="/unauthorized" element={<Unauthorized />} />

      <Route path="*" element={<Unauthorized />} />

    </>
  );
}